module.exports = __webpack_public_path__ + "img/Restaurant6.7678936b.png";